module.exports = __webpack_public_path__ + "img/hero-sm.8caa03db.png";